<template>
 <div class="faq-wrap pt-20 pb-20">
    <div class="container mx-auto px-6">
      <div class="card-body p-4">
        <Form ref="demandeForm" @submit="addDemande" :validation-schema="currentSchema">
          <!-- Toutes les informations en une seule page -->
          <div class="step-content">
            <!-- === Informations de l'étudiant === -->
            <div class="row">          
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="nom" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Nom<span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer le nom" />
                  <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="prenom" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Prénom <span class="text-danger">*</span>
                  </label>
                  <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer le prénom" />
                  <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="email" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Email <span class="text-danger">*</span>
                  </label>
                  <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer l'email" />
                  <ErrorMessage name="email" class="text-danger" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone 1 <span class="text-danger">*</span>
                  </label>
                  <Field name="telephone1" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field" defaultCountry="BJ" mode="international" @validate="validate" class="shadow-none fs-md-15 text-black py-2" />
                  </Field>
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
                  <ErrorMessage name="telephone1" class="text-danger" />
                </div>
              </div>
               <div class="col-md-3">
                <div class="modern-input-group">
                  <label for="dateNaissance" class="modern-label">
                    <i class="fas fa-calendar me-2"></i>
                    Date de naissance<span class="text-danger">*</span>
                  </label>
                  <Field name="dateNaissance" type="date" :max="currentDate" class="form-control shadow-none fs-md-15 text-black modern-input" />
                  <ErrorMessage name="dateNaissance" class="text-danger" />
                </div>
              </div>
           
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Informations complémentaires <span class="text-danger">*</span>
                  </label>
                  <Field name="biographie" rows="2" as="textarea" placeholder="Ajouter d'autres informations" v-slot="{ field }" class="form-control shadow-none rounded-0 text-black">
                    <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
                  </Field>
                  <ErrorMessage name="biographie" class="text-danger" />
                </div>
              </div>
             
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Sexe <span class="text-danger">*</span>
                  </label>
                  <Field name="sexe" type="text" v-slot="{ field }">
                    <Multiselect :searchable="true" :options="[{ label: 'Masculin', value: 'Masculin' }, { label: 'Féminin', value: 'Féminin' }]" v-model="field.value" v-bind="field" placeholder="Sélectionner le sexe" />
                  </Field>
                  <ErrorMessage name="sexe" class="text-danger" />
                </div>
              </div>
         
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Pays de résidence <span class="text-danger">*</span>
                  </label>
                  <Field name="nationalite" v-model="nationalite" v-slot="{ field }">
                    <Multiselect :options="countries" :searchable="true" track-by="value" label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner le pays de résidence" />
                  </Field>
                  <ErrorMessage name="nationalite" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Commune <span class="text-danger">*</span>
                  </label>
                  <Field name="commune" v-slot="{ field }">
                    <Multiselect :options="communeOptions" @change="communeChange($event)" :searchable="true" track-by="value" label="label" v-model="selectedCommune" v-bind="field" placeholder="Sélectionner la commune" />
                  </Field>
                  <ErrorMessage name="commune" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Quartier <span class="text-danger">*</span>
                  </label>
                  <Field name="quartier" v-slot="{ field }">
                    <Multiselect :options="quartierOptions" :searchable="true" track-by="value" label="label" v-model="selectedQuartier" v-bind="field" noOptionsText="Sélectionner d'abord une commune" placeholder="Sélectionner le quartier" />
                  </Field>
                  <ErrorMessage name="quartier" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Qualification <span class="text-danger">*</span>
                  </label>
                  <Field name="qualification" v-slot="{ field }">
                    <Multiselect :options="qualificationOptions" :searchable="true" track-by="label" label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner la qualification" />
                  </Field>
                  <ErrorMessage name="qualification" class="text-danger" />
                </div>
              </div>
                <div class="col-md-4">
                <div class="modern-input-group">
                  <label for="anneeExperience" class="modern-label">
                    <i class="fas fa-book me-2"></i>
                    Nombre d'années d'expériences
                  </label>
                  <Field name="anneeExperience" type="number" class="form-control shadow-none fs-md-15 text-black modern-input" placeholder="Entrer le nombre" />
                  <ErrorMessage name="anneeExperience" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Activité <span class="text-danger">*</span>
                  </label>
                  <Field name="activites" v-slot="{ field }">
                    <Multiselect :options="activiteOptions" :searchable="true" mode="tags" track-by="label" label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
                  </Field>
                  <ErrorMessage name="activites" class="text-danger" />
                </div>
              </div>
          
            </div>
          </div>

          <!-- Bouton Enregistrer -->
          <div class="form-navigation mt-4">
            <button 
              class="btn btn-success me-3" 
              type="submit" 
              :disabled="isSubmitting"
            >
              <i class="fas fa-plus me-2" v-if="!isSubmitting"></i>
              <i class="fas fa-spinner fa-spin me-2" v-if="isSubmitting"></i>
              {{ isSubmitting ? 'Enregistrement en cours...' : 'Enregistrer' }}
            </button>
            <router-link to="/" class="btn btn-danger border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16">
              <i class="fas fa-times me-2"></i>
              Annuler
            </router-link>
          </div>
        </Form>
      </div>
    </div>
    <br /><br />
    <AddParentModal @close="handleClose" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import { AxiosError } from 'axios';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import AddParentModal from '@/components/DemandeInscription/AddParent.vue';
import { countries } from '@/components/DemandeInscription/countries';
import { VueTelInput } from 'vue3-tel-input';

export default defineComponent({
  name: 'AddDemande',
  components: {
    Form,
    Field,
    ErrorMessage,
    AddParentModal,
    Multiselect,
    VueTelInput
  },
  setup: () => {
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const demandeForm = ref<any>(null);
    const parents = ref<any[]>([]);
    const parentsOptions = ref([]);
    const niveauOptions = ref([]);
    const filiereOptions = ref([]);
    const anneeOptions = ref([]);
    const countriesRef = ref(countries);
    const router = useRouter();
    const nationalite = ref('Bénin');
    const isSubmitting = ref(false);

    const telephone1 = ref();
    const validPhone = ref<boolean>(false);

    const qualificationOptions = ref([]);
    const activiteOptions = ref([]);
    const quartierOptions = ref([]);
    const selectedQuartier = ref();
    const selectedCommune = ref();
    const communeOptions = ref([]);
    const quartier = ref();
    const commune = ref();

    const loadParents = async () => {
      try {
        const { data } = await ApiService.get('/parents');
        parents.value = data.data.data;
        parentsOptions.value = data.data.data.map((parent: any) => ({
          value: parent.id,
          label: `${parent.nom} ${parent.prenom}`,
        }));
      } catch (err) {
        error('Erreur lors du chargement des parents');
      }
    };

    const handleClose = (values) => {
      loadParents();
    };

    const currentSchema = Yup.object().shape({
   
      nom: Yup.string().required('Le nom est obligatoire'),
      prenom: Yup.string().required('Le prénom est obligatoire'),
      email: Yup.string().email('Email invalide').required("L'email est obligatoire"),
      telephone1: Yup.string().required('Le téléphone est obligatoire'),
      dateNaissance: Yup.date()
        .required('La date de naissance est obligatoire')
        .max(new Date(), 'La date de naissance ne peut pas être dans le futur'),
      sexe: Yup.string().required('Le sexe est obligatoire'),
      nationalite: Yup.string().required('La nationalité est obligatoire'),
      anneeExperience: Yup.number().notRequired(),
      commune: Yup.number().required('La commune est obligatoire'),
      quartier: Yup.number().required('Le quartier est obligatoire'),
      qualification: Yup.number().required('La qualification est obligatoire'),
      activites: Yup.array().required('Au moins une activité est requise').min(1, 'Sélectionnez au moins une activité'),
    });

    const addDemande = async (values, { resetForm }) => {
      isSubmitting.value = true;
      try {
        const formData = new FormData();
        formData.append('nom', values.nom);
        formData.append('prenom', values.prenom);
        formData.append('email', values.email);
        formData.append('sexe', values.sexe);
        formData.append('telephone1', telephone1.value || values.telephone1);
        formData.append('dateNaissance', values.dateNaissance);
        formData.append('qualification', values.qualification);
        formData.append('anneeExperience', values.anneeExperience || '0');
        formData.append('dateDemandeInscription', new Date().toISOString().split('T')[0]);
        formData.append('nationalite', values.nationalite);
        formData.append('commune', values.commune);
        formData.append('quartier', values.quartier);
       
        if (values.biographie) {
          formData.append('biographie', values.biographie);
        }
        if (values.activites && values.activites.length > 0) {
          formData.append('activites', JSON.stringify(values.activites));
        }

        const response = await ApiService.post('/demandes', formData);

        if (response.data.code === 201) {
          success(response.data.message);
          resetForm();
          router.push({ name: 'ActualitePostePage'});
        }
      } catch (err) {
        const axiosError = err as AxiosError<{ message?: string }>;
        error(axiosError.response?.data?.message || 'Une erreur est survenue.');
      } finally {
        isSubmitting.value = false;
      }
    };

    const fetchCommunes = async () => {
      try {
        const { data } = await ApiService.get('/communes');
        communeOptions.value = data.data.data.map((item: any) => ({
          value: item.id,
          label: item.libelle,
        }));
      } catch (err) {
        error('Erreur lors du chargement des communes');
      }
    };

    const communeChange = async (value) => {
      if (value) {
        commune.value = value;
        quartierOptions.value = [];
        selectedQuartier.value = null;
        quartier.value = null;
        try {
          const { data } = await ApiService.get(`/communes/quartiers/${value}`);
          quartierOptions.value = data.data.map((quartier: any) => ({
            label: quartier.libelle,
            value: quartier.id,
          }));
        } catch (err) {
          error('Erreur lors du chargement des quartiers');
        }
      } else {
        commune.value = null;
        quartierOptions.value = [];
        selectedQuartier.value = null;
        quartier.value = null;
      }
    };

    watch(selectedQuartier, (newValue) => {
      quartier.value = newValue;
    });

    watch(selectedCommune, (newValue) => {
      commune.value = newValue;
      if (newValue) {
        communeChange(newValue);
      }
    });

    const validate = (phoneObject) => {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid) {
        telephone1.value = phoneObject.number;
      } else {
        telephone1.value = '';
      }
    };

    /*const getAllFiliere = async () => {
      try {
        const response = await ApiService.get('/all/filieres');
        filiereOptions.value = response.data.data.data.map((filiere: any) => ({
          value: filiere.id,
          label: filiere.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des filières:', error);
      }
    };

    const getAllNiveaux = async () => {
      try {
        const response = await ApiService.get('/all/niveaux');
        niveauOptions.value = response.data.data.data.map((niveau: any) => ({
          value: niveau.id,
          label: niveau.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des niveaux:', error);
      }
    };

    const getAllAnnees = async () => {
      try {
        const response = await ApiService.get('/all/annees');
        anneeOptions.value = response.data.data.data.map((annee: any) => ({
          value: annee.id,
          label: annee.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des années académiques:', error);
      }
    };
*/
    const fetchQualification = async () => {
      try {
        const response = await ApiService.get('/all/qualifications');
        qualificationOptions.value = response.data.data.data.map((qualification) => ({
          value: qualification.id,
          label: qualification.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des qualifications:', error);
      }
    };

    const fetchActivite = async () => {
      try {
        const response = await ApiService.get('/all/activites');
        activiteOptions.value = response.data.data.data.map((activite) => ({
          value: activite.id,
          label: activite.libelle,
        }));
      } catch (error) {
        console.error('Erreur lors du chargement des activités:', error);
      }
    };

    

    onMounted(() => {
    
      
      fetchActivite();
      fetchQualification();
     
      fetchCommunes();
    });

    return {
      currentSchema,
      addDemande,
      demandeForm,
      niveauOptions,
      handleClose,
      parentsOptions,
      filiereOptions,
      anneeOptions,
      currentDate,
      selectedQuartier,
      quartierOptions,
      communeChange,
      communeOptions,
      commune,
      validPhone,
      validate,
      nationalite,
      countries: countriesRef,
      isSubmitting,
      quartier,
      qualificationOptions,
      activiteOptions
    };
  },
});
</script>

<!-- STYLE INCHANGÉ -->
<style scoped>
/* [Tout ton style original ici – inchangé] */
.modern-form-container {
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

.modern-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.modern-input-group,
.modern-select-group {
  position: relative;
  margin-bottom: 1.5rem;
}

.modern-label {
  display: block;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 14px;
}

.modern-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.modern-input:focus {
  outline: none;
  border-color: #FFBE00;
  box-shadow: 0 0 0 0.2rem rgba(255, 190, 0, 0.25);
  transform: translateY(-1px);
}

.modern-multiselect {
  border-radius: 8px !important;
  border: 2px solid #e9ecef !important;
  transition: all 0.3s ease !important;
}

.modern-multiselect:focus-within {
  border-color: #007bff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  transform: translateY(-1px);
}

.modern-select-group {
  position: relative;
  z-index: 50;
}

.modern-select-group .multiselect--open {
  z-index: 1000;
  position: relative;
}

.modern-multiselect :deep(.multiselect__content-wrapper) {
  z-index: 1001 !important;
  position: absolute !important;
  background: white !important;
  border: 1px solid #e9ecef !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  max-height: 200px !important;
  overflow-y: auto !important;
}

.modern-multiselect :deep(.multiselect__option) {
  padding: 8px 12px !important;
  border-bottom: 1px solid #f8f9fa !important;
}

.modern-multiselect :deep(.multiselect__option:hover) {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
}

.modern-multiselect :deep(.multiselect__option--selected) {
  background: #007bff !important;
  color: white !important;
}

.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 0.25rem;
  display: block;
}

.form-navigation {
  display: flex;
  justify-content: start;
  margin-left: 15px;
  align-items: center;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 2px solid #e9ecef;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  position: relative;
  overflow: hidden;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-success {
  background: linear-gradient(135deg, #34cc57, #05855f);
  border: 2px solid #28a745;
  color: white;
}

.btn-success:hover {
  background: linear-gradient(135deg, #218838, #1ea085);
  border-color: #1e7e34;
}

.btn:disabled {
  opacity: 0.6 !important;
  transform: none !important;
  cursor: not-allowed !important;
}

@media (max-width: 768px) {
  .modern-form-container {
    padding: 1rem 0.5rem;
  }

  .form-navigation {
    flex-direction: column;
    gap: 0.5rem;
  }

  .form-navigation .btn {
    width: 100%;
    max-width: 200px;
  }
}
</style>